/* eslint-disable */

import type { LangPackStringValue } from '../../api/types';
import type { LangKey } from '../../types/language';

export default {
  "WrongNumber": "号码不对？",
  "SentAppCode": "我们已将验证码发送到你其他设备上的 **Telegram** 应用。",
  "LoginJustSentSms": "我们已通过短信向你发送验证码，请在上方输入。",
  "LoginHeaderPassword": "输入密码",
  "LoginEnterPasswordDescription": "你已启用两步验证，因此你的账号受到额外密码的保护。",
  "StartText": "请确认你的国家代码\n并输入你的手机号。",
  "LoginPhonePlaceholder": "你的手机号",
  "LoginNext": "下一步",
  "LoginQRLogin": "通过二维码登录",
  "LoginQRTitle": "通过二维码登录 Telegram",
  "LoginQRHelp1": "在手机上打开 Telegram",
  "LoginQRHelp2": "前往 **设置** > **设备** > **关联桌面设备**",
  "LoginQRHelp3": "将手机对准此屏幕以确认登录",
  "LoginQRCancel": "通过手机号登录",
  "YourName": "你的姓名",
  "LoginRegisterDesc": "输入你的姓名并添加头像。",
  "LoginRegisterFirstNamePlaceholder": "名字",
  "LoginRegisterLastNamePlaceholder": "姓氏",
  "LoginSelectCountryTitle": "国家/地区",
  "CountryNone": "未找到国家/地区",
  "PleaseEnterPassword": "输入你的新密码",
  "ErrorPhoneNumberInvalid": "手机号无效，请重试。",
  "ErrorCodeInvalid": "验证码无效，请重试。",
  "ErrorIncorrectPassword": "密码无效，请重试。",
  "ErrorPasswordFlood": "尝试次数过多，请稍后再试。",
  "ErrorPhoneBanned": "此手机号已被封禁。",
  "ErrorFloodTime": "尝试次数过多，请在 {time} 后重试。",
  "ErrorUnexpected": "意外错误",
  "ErrorUnexpectedMessage": "意外错误：{error}"
} as Record<LangKey, LangPackStringValue>;

